import {AxiosError} from "axios";

interface ErrorResponse {
  message?: string;
  details?: string;
}

export const mapErrorToMessage = (error: Error): string => {
  if ((error as any).response) {
    const axiosError = error as AxiosError;
    if (axiosError.response.data) {// Internal server or Unsupported operation error
      const errorResponse = axiosError.response.data as ErrorResponse;
      if (errorResponse.message) {
        return errorResponse.message;
      } else if (errorResponse.details) {
        return errorResponse.details;
      } else if (typeof axiosError.response.data === "string") {
        return axiosError.response.data;
      }
    }
  }
  return null;
}